export const grid = () => ({
    display: 'grid',
    gridTemplateColumns: '1.97fr 1fr',
    gridColumnGap: '1rem',
    gridRowGap: '1.25rem',
    margin: '0 0 1.25rem',
});
